import React, { useState } from 'react';
import XCircleFillIcon from '../../../assets/icons/XCircleFill';
import { useAddApiKeyMutation } from '../api/ApiCredentials';
import Toast from '../../../components/ToastNotification';

const GenerateApiKeyModal = ({ onClose, onSuccess }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [nameError, setNameError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const [addApiKeyApi] = useAddApiKeyMutation();

    const validate = () => {
        if (!name.trim()) {
            setNameError('Name is required.');
            return false;
        }
        if (name.trim().length > 100) {
            setNameError('Name cannot exceed 100 characters.');
            return false;
        }
        setNameError('');
        return true;
    };

    const handleGenerate = async () => {
        if (!validate()) return;

        try {
            setIsLoading(true);
            const newCred = await addApiKeyApi({
                name: name.trim(),
                description: description.trim() || undefined,
            }).unwrap();
            onSuccess(newCred.data);
        } catch (err) {
            const message = err?.data?.message || err?.message || 'Failed to generate API key';
            // Surface duplicate-name errors inline on the name field
            if (message.toLowerCase().includes('already exists')) {
                setNameError(message);
            } else {
                Toast.error(message);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleNameChange = (e) => {
        setName(e.target.value);
        if (nameError) setNameError('');
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal-content"
                style={{ width: '480px' }}
                onClick={(e) => e.stopPropagation()}
            >
                <h3>Generate API Key</h3>
                <button className="close-btn" onClick={onClose}>
                    <XCircleFillIcon size={24} />
                </button>

                <p style={{ color: '#555', fontSize: '14px', marginBottom: '16px' }}>
                    Provide a name to identify this API key. An optional description can help clarify its purpose.
                </p>

                <div className="generate-key-field">
                    <label className="generate-key-label">
                        Name <span style={{ color: '#b71c1c' }}>*</span>
                    </label>
                    <input
                        type="text"
                        className={`generate-key-input${nameError ? ' input-error' : ''}`}
                        placeholder="e.g. Production Integration"
                        value={name}
                        onChange={handleNameChange}
                        maxLength={100}
                        autoFocus
                    />
                    {nameError && (
                        <span className="generate-key-error">{nameError}</span>
                    )}
                </div>

                <div className="generate-key-field">
                    <label className="generate-key-label">
                        Description <span style={{ color: '#888', fontWeight: 400 }}>(optional)</span>
                    </label>
                    <textarea
                        className="generate-key-textarea"
                        placeholder="e.g. Used for sending automated notifications from the CRM system"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        maxLength={500}
                        rows={3}
                    />
                </div>

                <div className="layout_footer" style={{ marginTop: '20px' }}>
                    <button
                        className="save-btn"
                        onClick={handleGenerate}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Generating...' : 'Generate'}
                    </button>
                    <button className="cancel-btn" onClick={onClose} disabled={isLoading}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GenerateApiKeyModal;
